export const OrderActionType = {
  LOAD_LIST_START: 'order/LOAD_LIST_START',
  LOAD_LIST_SUCCESS: 'order/LOAD_LIST_SUCCESS',
  LOAD_LIST_FAILURE: 'order/LOAD_LIST_FAILURE',
  SET_LIST_TOTAL: 'order/SET_LIST_TOTAL',
  SET_SELECTED: 'order/SET_SELECTED',
  UPDATE_STATUS_START: 'order/UPDATE_STATUS_START',
  UPDATE_STATUS_SUCCESS: 'order/UPDATE_STATUS_SUCCESS',
  SET_ERROR: 'order/SET_ERROR',
  CLEAR_ERROR: 'order/CLEAR_ERROR',
}

export function createInitialOrderState() {
  return {
    orders: [],
    listTotal: 0,
    listPage: 1,
    listLimit: 20,
    selectedOrder: null,
    listLoading: false,
    mutationLoading: false,
    error: null,
  }
}

export function orderReducer(state, action) {
  switch (action.type) {
    case OrderActionType.LOAD_LIST_START:
      return { ...state, listLoading: true, error: null }
    case OrderActionType.LOAD_LIST_SUCCESS: {
      const { items, total, page, limit } = action.payload
      return {
        ...state,
        listLoading: false,
        orders: items,
        listTotal: total,
        listPage: page,
        listLimit: limit,
      }
    }
    case OrderActionType.LOAD_LIST_FAILURE:
      return { ...state, listLoading: false, error: action.payload }
    case OrderActionType.SET_LIST_TOTAL:
      return { ...state, listTotal: action.payload }
    case OrderActionType.SET_SELECTED:
      return { ...state, selectedOrder: action.payload }
    case OrderActionType.UPDATE_STATUS_START:
      return { ...state, mutationLoading: true, error: null }
    case OrderActionType.UPDATE_STATUS_SUCCESS: {
      const updated = action.payload
      const matches = (o) =>
        o &&
        (o.id === updated.id ||
          (updated.orderReference &&
            o.orderReference &&
            String(o.orderReference) === String(updated.orderReference)))
      const mergeOrder = (o) => (matches(o) ? { ...o, ...updated } : o)
      return {
        ...state,
        mutationLoading: false,
        orders: state.orders.map(mergeOrder),
        selectedOrder: matches(state.selectedOrder)
          ? mergeOrder(state.selectedOrder)
          : state.selectedOrder,
      }
    }
    case OrderActionType.SET_ERROR:
      return { ...state, error: action.payload, listLoading: false, mutationLoading: false }
    case OrderActionType.CLEAR_ERROR:
      return { ...state, error: null }
    default:
      return state
  }
}
